/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Filter Icon component.
 */
export const FilterIcon = ({
  size = IconSize.small,
  color = dlsColor('grey3')
}: IconProps) => {
  const {iconSize, iconColor, isDark} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width={iconSize} height={iconSize} rx='8' fill={isDark ? 'none' : dlsColor('grey6')} />
      <path d='M20.6003 11.7381C20.7807 11.405 20.5395 11 20.1606 11H10.8394C10.4605 11 10.2193 11.405 10.3997 11.7381L13.4653 17.3987C13.5049 17.4718 13.5256 17.5536 13.5256 17.6368V20.4096C13.5256 20.6289 13.6686 20.8227 13.8781 20.8874L16.8339 21.8001C17.1555 21.8994 17.4814 21.6589 17.4814 21.3223V17.5127C17.4814 17.5112 17.4802 17.5101 17.4788 17.5101C17.4768 17.5101 17.4755 17.5079 17.4765 17.5062L20.6003 11.7381Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default FilterIcon;
